import { StoreState } from '@/core/models/store.interface';
import { ColorTheme } from '@nxtpeople/nxt-vue-library';
import { Module } from 'vuex';
import { ColorThemeService } from './color-theme.service';

const service = new ColorThemeService();

export interface ColorThemeState {
   colorThemes: Array<ColorTheme>;
}

const ColorThemeStore: Module<ColorThemeState, StoreState> = {
   namespaced: true,
   state: {
      colorThemes: [],
   },
   getters: {},
   mutations: {
      SET_COLOR_THEMES(state, colorThemes: Array<ColorTheme>) {
         state.colorThemes = colorThemes;
      },
   },
   actions: {
      async getColorThemes(context) {
         const response = await service.getColorThemes();
         context.commit('SET_COLOR_THEMES', response);
         return response;
      },
   },
};

export default ColorThemeStore;
